interface TabHeaderProps {
  title: string;
  children: React.ReactNode;
}

export function TabHeader({ title, children }: TabHeaderProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <h2 className="text-lg font-semibold">{title}</h2>
      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
}
